var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopylink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.335,
    height: 17.5,
    viewBox: "0 0 15.335 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy_link",
    "data-name": "copy link",
    d: "M147.894,46.8a5.657,5.657,0,0,1-3.021.814,2.451,2.451,0,0,1-1.917-1.455,2.451,2.451,0,0,1-.3-2.388,6.289,6.289,0,0,1,2.73-2.522,6.288,6.288,0,0,1,3.549-1.1,2.451,2.451,0,0,1,1.917,1.455,2.451,2.451,0,0,1,.3,2.388,3.239,3.239,0,0,1-.425.681,7.817,7.817,0,0,1,.808,1.155q.179.309.325.62a4.482,4.482,0,0,0,.745-5.857c-1.772-3.07-4.725-3.12-8.233-1.094-3.143,1.815-4.621,4.075-3.62,6.733-2.606,1.894-3.512,4.208-1.96,6.9,1.772,3.07,4.725,3.12,8.233,1.094s4.942-4.607,3.169-7.677c-1.416-2.452-3.584-2.977-6.188-2.057a.469.469,0,0,0-.017.181,2.545,2.545,0,0,0,.778,1.347.5.5,0,0,0,.262.091,1.414,1.414,0,0,0,.236,0,11.232,11.232,0,0,1,1.258-.007,2.09,2.09,0,0,1,1.372.7Zm-6.13,1.2c1.693,2.1,4.186,2.1,7.1.58a2.052,2.052,0,0,1-.125,1.364,6.289,6.289,0,0,1-2.73,2.522,6.288,6.288,0,0,1-3.549,1.1,3.106,3.106,0,0,1-2.219-3.844A4.774,4.774,0,0,1,141.764,48Z",
    transform: "translate(-138.03 -38.105)",
    fill: "#009bad",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylink);
export default __webpack_public_path__ + "static/media/copy link.c5bb6d4d6e650dc2e150f40e80eb4a2e.svg";
export { ForwardRef as ReactComponent };